<template>
  <div>
    <div class="navbar-fixed" style="z-index: 9999; ">
      <nav >
        <div class="nav-wrapper " :style="'background-color: ' + this.retorno.empresa.cor_primaria">
          <a class="brand-logo">
            <div align="center"><img src="https://res.cloudinary.com/sirrus/image/upload/v1607538363/delivery/comercio/assets/logo-sirrus-delivery-comercio_mvlzrr.png" class="logo"></div>
          </a>
        </div>
      </nav>
    </div>
    <div class="container">
      <br>
      <label>Status</label>
      <strong class="status" :style="'background-color:'+traduzirFormaPagamento(JSON.parse(this.retorno.status))[1] ">{{traduzirFormaPagamento(JSON.parse(this.retorno.status))[0] }}</strong>
      <hr>
      <label>Referência</label>
      <strong>{{this.retorno.chave_rastreamento }}</strong>
      <hr>
      <label>Empresa</label>
      <strong>{{this.retorno.empresa.nome }}</strong>
      <hr>
      <label>Cliente</label>
      <strong>{{this.retorno.pedido.nome_cliente }}</strong>
      <hr>
      <label>Valor Total</label>
      <strong>R$ {{parseFloat(this.retorno.pedido.valor_total).toFixed(2) }}</strong>
      <hr>
      <label>Data</label>
      <strong>
        {{
          momentJs
            .utc(this.retorno.created_at)
            .tz("America/Porto_Velho")
            .format("DD/MM/YYYY HH:mm:ss")
        }}
      </strong>
      <hr>
      <label>Última atualização</label>
      <strong>
        {{
          momentJs
            .utc(this.retorno.updated_at)
            .tz("America/Porto_Velho")
            .format("DD/MM/YYYY HH:mm:ss")
        }}
      </strong>
    </div>
  </div>

</template>

<script>

import axios from 'axios'
import momentTz from 'moment-timezone'

export default {
  name: "ReciboPagamentoLinkMercadoPago",
  data () {
    return {
      pagamentoIniciado: true,
      retorno: {
        empresa_id: 0,
        chave_rastreamento:"",
        status:"{}",
        empresa: {
          id: 0,
          nome: '',
          usuario_url: ''
        },
        pedido:{
          valor_total:0,
          nome_cliente:''
        }
      }
    }
  },
  methods:{
    traduzirFormaPagamento(formaPagamento){
      let formaTraduzida = ';'
      let color = '#ffdea2'
      switch (formaPagamento) {
        case 'approved':
          formaTraduzida = 'O pagamento foi aprovado.';
          color = '#88d888';
          this.pagamentoIniciado = true;
          break;
        case 'authorized':
          formaTraduzida = 'O pagamento foi autorizado, mas ainda não capturado.';
          this.pagamentoIniciado = true;
          break;
        case 'in_process':
          formaTraduzida = 'O pagamento está sendo revisado.';
          this.pagamentoIniciado = true;
          break;
        case 'in_mediation':
          formaTraduzida = 'Os usuários iniciaram uma disputa.';
          this.pagamentoIniciado = true;
          break;
        case 'rejected':
          formaTraduzida = 'O pagamento foi rejeitado. O usuário pode tentar o pagamento novamente.';
          this.pagamentoIniciado = true;
          break;
        case 'cancelled':
          formaTraduzida = 'O pagamento foi cancelado por uma das partes ou porque o prazo de pagamento expirou.';
          this.pagamentoIniciado = true;
          break;
        case 'refunded':
          formaTraduzida = 'O pagamento foi devolvido ao usuário.';
          this.pagamentoIniciado = true;
          break;
        case 'refunded':
          formaTraduzida = 'Foi feito um estorno no cartão de crédito do comprador.';
          this.pagamentoIniciado = true;
          break;
        default:
          formaTraduzida = 'Pagamento não iniciado :(';
          this.pagamentoIniciado = false;
          break;
      }

      return [formaTraduzida,color];

    }
  },
  beforeCreate(){
    momentTz.tz.setDefault("America/Porto_Velho")
  },
  mounted() {
    axios.get(this.$store.state.apiUrl + 'mercadopago/pagamentos?rastrear='+ this.$route.params.id).then(res=>{
      this.retorno = res.data
      console.log(this.retorno)
    }).catch(err=>{
      console.log(err.response)
    })
  }
}
</script>

<style scoped>
.logo {
  padding: 9px;
  width: 210px;
}

.status{
  border-radius: 10px;
  padding: 3px;
  font-weight: 600;
  font-size: small;
}

@media only screen and (max-width : 992px) {
  .logo {
    padding-top: 5px;
    width: 185px;
  }
}

.sidenav li > a {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Paginas/ReciboPagamentoLinkMercadoPago.vue